


























































































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import IconButton from "@/components/IconButton.vue";
import CheckBox from "@/components/CheckBox.vue";
import DateTimeDisplay from "@/components/DateTimeDisplay.vue";
import SyncStatusBadge from "../SyncStatusBadge.vue";
import VerkInvoiceAccList from "./VerkInvoiceAccList.vue";
import VerkInvoiceHistory from "../historyViews/VerkInvoiceHistory.vue";
import { ColumnType } from "@/components/apiSearch/models/ApiSearch";
import { verkInvoiceStatusColor } from "./verkInvoiceStatus";
import configuration from "@/models/Configuration";

interface Methods {
  statusColor(status: number): string;
  /** Könyvelési időszak megjelenítése: ÉÉÉÉ/HH */
  periodDisplay(item: any): string;
  /** Futás-előzmények lenyitása / bezárása (a kontír-fejekkel kölcsönösen kizáró) */
  toggleHistory(item: any): void;
  /** Kontírozás fejek lenyitása / bezárása (az előzményekkel kölcsönösen kizáró) */
  toggleAccs(item: any): void;
}

interface Computed {
  url: string;
  columns: any[];
  /** Az előzmény gomb látszik-e a soron (a SyncEntityList szabálya szerint). */
  isHistoryButtonVisible: boolean;
}

interface Props {
  /** Hibás lista (igaz) vagy sikeres lista (hamis) — a backend bucketje */
  onlyErrors: boolean;
  name: string;
  refreshEvent: string;
  extraFilter: object;
  color: string;
  /** Előzmény mód — nincs kijelölés, csak megtekintés */
  historyMode: boolean;
}

/**
 * Verk bizonylat vezérrekordok (hmifcapiverkinv) listája — a Verk interfész + kimenő számla típus saját,
 * háromszintű listájának 1. szintje (a főoldalon a hibás és a sikeres kártya is ezt használja, eltérő
 * onlyErrors / szűrő propokkal, a SyncEntityList mintájára). Belső számlánként csak a legutolsó futás
 * rekordja látszik; a sor lenyitva a korábbi futások előzményét VAGY a kontírozás fejeket (azok lenyitva
 * a tételeket) mutatja.
 */
export default Vue.extend<{}, Methods, Computed, Props>({
  name: "VerkInvoiceSyncList",

  components: {
    ApiSearchPage,
    IconButton,
    CheckBox,
    DateTimeDisplay,
    SyncStatusBadge,
    VerkInvoiceAccList,
    VerkInvoiceHistory,
  },

  props: {
    onlyErrors: { type: Boolean, default: false },
    name: { type: String, required: true },
    refreshEvent: { type: String, default: "" },
    extraFilter: { type: Object, default: () => ({}) },
    color: { type: String, default: "" },
    historyMode: { type: Boolean, default: false },
  },

  computed: {
    url(): string {
      return `iface-sync-verk-invoice/search/${this.onlyErrors}`;
    },

    /**
     * Előzmény módban mindig van előzmény gomb, a főoldalon viszont csak akkor, ha az előzmények
     * nincsenek külön menüpontba választva — mint a SyncEntityList-en.
     */
    isHistoryButtonVisible(): boolean {
      return this.historyMode || !configuration.sysParams.ifaceSyncIsSepHistory;
    },

    columns(): any[] {
      return [
        { field: "selected", title: "", cell: "command", filterable: false, sortable: false, checkBox: true, width: 90 },
        { field: "invNo", title: "Belső számla", width: 130, cell: "invNo" },
        { field: "customerNo", title: "Verk ügyfélszám", width: 120, type: ColumnType.Right, cell: "disabledText" },
        { field: "recDate", title: "Bizonylat kelte", width: 115, type: ColumnType.Date, filterable: false },
        { field: "accDate", title: "Könyvelés dátuma", width: 115, type: ColumnType.Date, filterable: false },
        { field: "dueDate", title: "Esedékesség", width: 115, type: ColumnType.Date, filterable: false },
        { field: "recYear", title: "Időszak", width: 80, cell: "period", filterable: false },
        { field: "origReceiptNo", title: "Eredeti számla", width: 150, cell: "disabledText" },
        { field: "accCount", title: "Bizonylatok", width: 110, cell: "accCount", filterable: false },
        { field: "statusName", title: "Státusz", width: 140, cell: "statusName", filterable: false },
        { field: "errMsg", title: "Hibaüzenet", width: 220, cell: "disabledText", fieldClass: "error-text-col", visible: this.onlyErrors },
        { field: "insDateTime", title: "Rögzítve", width: 110, filterable: false, cell: "insDateTime" },
      ];
    },
  },

  methods: {
    statusColor(status) {
      return verkInvoiceStatusColor(status);
    },

    periodDisplay(item) {
      if (!item.recYear) return "";
      const month = String(item.recMonth ?? 0).padStart(2, "0");
      return `${item.recYear}/${month}`;
    },

    toggleHistory(item) {
      if (item.showDetails && item.showHistory) {
        item.showDetails = false;
        item.showHistory = false;
      } else {
        item.showDetails = true;
        this.$set(item, "showHistory", true);
        this.$set(item, "showAccs", false);
      }
    },

    toggleAccs(item) {
      if (item.showDetails && item.showAccs) {
        item.showDetails = false;
        item.showAccs = false;
      } else {
        item.showDetails = true;
        this.$set(item, "showAccs", true);
        this.$set(item, "showHistory", false);
      }
    },
  },
});
